export default __webpack_public_path__ + "static/media/42_mobile.917be1ae.jpg";